import React, { Component } from 'react';
import moment from 'moment';
import './individualMeeting.scss';

/** displays a survey form for a participant to fill out, only valid to fill out once */
class IndividualMeetingComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    const { title, startTime, endTime, onClick} = this.props;

    return (
      <div className="schedule-row" onClick={onClick}>
        <div>{moment(startTime).format('LT')} - {moment(endTime).format('LT')}</div>
        <div>{title}</div>
      </div>
    )
  }
}

export default IndividualMeetingComponent;



// WEBPACK FOOTER //
// src/scheduler/individualMeeting/individualMeeting.component.js